import React from 'react';
import { Link } from 'react-router-dom';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

function EmptyRetrunOrder() {
  return (
    <div className="ret-empty-card">
      <div className="ret-empty-icon-wrap">
        <AssignmentReturnOutlinedIcon />
      </div>

      <h3 className="ret-empty-title">No Return or Exchange Requests Yet</h3>

      <p className="ret-empty-sub">
        All your purchases are running smoothly! If you ever need to return or replace an item from a delivered order, you can easily initiate a request from your orders page.
      </p>

      <div className="ret-empty-actions">
        <Link to="/orders/Details/me" className="ret-btn-new">
          <ShoppingBagOutlinedIcon fontSize="small" />
          <span>View Delivered Orders</span>
        </Link>

        <Link to="/about/return-and-exchange" className="ret-btn-back">
          <HelpOutlineOutlinedIcon fontSize="small" />
          <span>Return Policy Guidelines</span>
        </Link>

        <Link to="/userprofile" className="ret-btn-back">
          <span>Back to My Profile</span>
        </Link>
      </div>
    </div>
  );
}

export default EmptyRetrunOrder;